<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header" v-if="header">
            <h5 class="modal-title">
              <strong>{{ header }}</strong>
            </h5>
          </div>
          <div class="modal-body" v-if="hasBody">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click.prevent
              @click="close()"
            >
              Fechar
            </button>
            <button
              v-if="hasDeleteButton"
              type="button"
              class="btn btn-danger"
              @click.prevent
              @click="deleteFunction()"
            >
              Deletar
            </button>
            <slot name="actions"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ['header', 'hasBody', 'hasDeleteButton', 'deleteFunction'],
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>
